/**
 * @file 任务创建-面试任务
 */
import { Modal } from '@seiue/ui'

import { EditTaskProps } from '../types'

import { EditInterviewTaskModal } from './EditInterviewTaskModal'

/**
 * 打开编辑面试任务弹窗
 *
 * @param param0 - 参数
 * @param param0.taskId - 任务 ID
 * @param param0.activityId - 活动 ID
 * @param param0.activityTaskOptions - 活动选项
 */
export const openEditInterviewTask = ({
  activityId,
  taskId,
  activityTaskOptions,
}: EditTaskProps) => {
  const { hide } = Modal.open({
    header: null,
    footer: null,
    fullScreen: true,
    bodyStyle: { padding: 0 },
    children: (
      <EditInterviewTaskModal
        onClose={() => {
          hide()
        }}
        taskId={taskId}
        activityId={activityId}
        activityTaskOptions={activityTaskOptions}
      />
    ),
  })
}
